import React, { useState } from 'react';
import DialogLayout from '../DialogLayout';
import Typography from '../../components/Typography/Typography';
import ASSETS from '../../assets';
import { IDKitWidget, VerificationLevel } from '@worldcoin/idkit';
import { ISuccessResult } from '@worldcoin/idkit-core';
import { verifyWorldId } from '../../http';

interface HumanVerificationModalProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onBack?: () => void;
  onCloseAll?: () => void;
  app_id: `app_${string}`;
  action: string;
  signal: string;
  partner?: boolean;
  verificationLevel: VerificationLevel;
  onVerificationSuccess?: (result: ISuccessResult) => void;
  onVerificationError?: (error: any) => void;
}

async function verify(proof: ISuccessResult, app_id: `app_${string}`, action: string, signal: string) {
  try {
    const response = await verifyWorldId({
      proof,
      app_id,
      action,
      signal,
    });

    console.log('handleVerify Success! (Backend)');
    return response.data;
  } catch (error) {
    console.error('Backend verification failed:', error);
    throw new Error('Verification failed: ' + (error as Error).message);
  }
}

const HumanVerificationModal: React.FC<HumanVerificationModalProps> = ({
  open,
  setOpen,
  onBack,
  onCloseAll,
  app_id,
  action,
  signal,
  partner = false,
  verificationLevel,
  onVerificationSuccess,
  onVerificationError
}) => {
  const [isVerifying, setIsVerifying] = useState(false);

  const handleClose = () => {
    if (onCloseAll) {
      onCloseAll();
    } else {
      setOpen(false);
    }
  };
  const handleBack = () => onBack ? onBack() : handleClose();

  const handleVerification = async (proof: ISuccessResult) => {
    setIsVerifying(true);
    try {
      const result = await verify(proof, app_id, action, signal);
      console.log(result ,"result here of verification")
      onVerificationSuccess?.(proof);
      handleClose();
    } catch (error) {
      console.error('Verification failed:', error);
      onVerificationError?.(error);
    } finally {
      setIsVerifying(false);
    }
  };

  const handleAppStoreClick = (url: string) => {
    window.open(url, "_blank");
  };

  const appStoreLinks = [
    {
      src: ASSETS.apple,
      alt: "App Store",
      url: "https://apps.apple.com/no/app/world-app-worldcoin-wallet/id1560859847?utm_source=chatgpt.com"
    },
    {
      src: ASSETS.google,
      alt: "Google Play",
      url: "https://play.google.com/store/apps/details?hl=en_US&id=com.worldcoin&utm_source=chatgpt.com"
    }
  ];

  return (
    <DialogLayout open={open}>
      <div className="w-full max-w-[532px] py-6 px-10 bg-[#F2F2F7] rounded-[15px] relative ">
      {/* Header */}
        <div className="flex items-center justify-between mb-3">
          <button
            onClick={handleBack}
            className="text-blue-600 font-bold text-sm hover:underline flex items-center gap-1"
          >
            <img src={ASSETS.arrow_left} alt="Back" className="w-3 h-3" />
            Back
          </button>
          <button
            onClick={handleClose}
            className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center hover:bg-gray-200 transition-colors"
          >
            <img src={ASSETS.cross} alt="Close" className="w-4 h-4" />
          </button>
        </div>

        {/* Title */}
        <Typography variant="h2" className="font-bold title">
            Human Verification
          </Typography>
          
          <Typography variant="body1" color="grey" className="text-sm leading-relaxed">
            Open your World App on your mobile device and scan the QR code below to verify your identity.
          </Typography>

        {/* QR Code Section */}
        <div className="bg-white rounded-lg p-6 mt-5 mb-4">
          <div className="flex justify-center">
            <IDKitWidget
              action={action}
              signal={signal}
              onError={error => {
                console.log('onError: ', error);
                onVerificationError?.(error);
              }}
              onSuccess={response => {
                console.log('onSuccess: ', response);
              }}
              handleVerify={handleVerification}
              app_id={app_id}
              partner={partner}
              verification_level={verificationLevel}
            >
              {({ open }) => (
                <div className="text-center">
                  {/* QR Code Placeholder - World ID will render the actual QR */}
                  <div 
                    onClick={open}
                    className="w-64 h-64 !bg-white mt-[40px] rounded-lg  flex items-center justify-center cursor-pointer hover:border-blue-300 transition-colors"
                  >
                    {isVerifying ? (
                      <div className="text-center">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-3"></div>
                        <Typography variant="body2" color="grey">
                          Verifying...
                        </Typography>
                      </div>
                    ) : (
                      <div className="">
                       
                       <img src={ASSETS.qr_code} alt="Close" className="h-[400px] w-[400px]" />

                      </div>
                    )}
                  </div>
                </div>
              )}
            </IDKitWidget>
          </div>
          <div className="text-center mt-[78px] mb-[15px]">
          <Typography variant="body1" color="grey" className="text-sm mb-2 font-semibold">
            Don't have World ID?
          </Typography>
          <div className="flex justify-center gap-2">
            {appStoreLinks.map((link) => (
              <img
                key={link.alt}
                src={link.src}
                alt={link.alt}
                className="w-32 h-12 cursor-pointer"
                onClick={() => handleAppStoreClick(link.url)}
              />
            ))}
          </div>
        </div>
        </div>

        {/* Footer - Download World App */}
      
      </div>
    </DialogLayout>
  );
};

export default HumanVerificationModal;
